/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { connect } from 'react-redux';
import * as styles from './style.css';
import { IUserTrackingData, trackMortgageBanner } from './tracking';
import { IUser } from '../../../shared/types/user';
import { IConfig } from '../../../shared/types/config';

interface IState {
  user: IUser;
  config: IConfig;
}

interface IMapStateToProps {
  user: IUserTrackingData;
}

export interface IFinanceMainPageProps extends IMapStateToProps {
  imageUrl: string;
  reference: string;
  bannerId: string;
}

export class FinanceMainPage extends React.Component<IFinanceMainPageProps> {
  public componentDidMount() {
    trackMortgageBanner('show', this.props.user, this.props.bannerId);
  }

  public render() {
    return (
      <a target="_blank" className={styles['banner']} href={this.props.reference} onClick={this.onLinkClick}>
        <img className={styles['banner-image']} src={this.props.imageUrl} />
      </a>
    );
  }

  private onLinkClick = () => {
    trackMortgageBanner('click', this.props.user, this.props.bannerId);
  };
}

export function mapStateToProps(state: IState): IMapStateToProps {
  const { user, config } = state;

  return {
    user: {
      abGroup: config.abGroup,
      cianUserId: user.id,
      userId: user.userId,
      type: user.userType || 'not_authorized',
      email: user.email,
    },
  };
}

export const FinanceMainPageConnected = connect(mapStateToProps)(FinanceMainPage);
